import FJTextStyle from './FJTextStyle';
import FJ3D from './style/FJ3D';

class FJTextStyle3D extends FJTextStyle {
    initStyles(props = {}) {
        let sytle = new FJ3D({
            ...props,
            offset: 60,
            angle: 120,
            color: '#9D7800',
            position: 'relative',
        });
        this._styles = [sytle];
    }

    /**
     * @description 得到需要进行设置的值
     * @returns {{color: [*], offset: *, direction: *}}
     */
    getAdjustInfo() {
        let shadow = this._styles[0];
        return {
            color: [shadow.color],
            offset: shadow.offset,
            direction: shadow.angle,
        };
    }

    /**
     * @description 设置对应的属性值
     * @param info
     */
    setAdjustInfo(info) {
        info.color.forEach((color, index) => {
            if (color !== '') this._styles[index].color = color;
        });

        if (info.offset !== '') {
            this._styles[0].offset = info.offset;
        }
        if (info.direction !== '') {
            this._styles[0].angle = info.direction;
        }
    }
}

export default FJTextStyle3D;
